/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FareBasisValidationData,
    FareBasisValidationDataFromJSON,
    FareBasisValidationDataFromJSONTyped,
    FareBasisValidationDataToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface GlobalFilterValidationData
 */
export interface GlobalFilterValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    effectiveDates?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    distributionChannels?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    agenciesAndGroups?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    routes?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    salesJourneys?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    marketingFlightNumbers?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    providers?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    fareTypes?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    carriers?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    bookingClasses?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof GlobalFilterValidationData
     */
    accountCodes?: ValidationMessage;
    /**
     * 
     * @type {FareBasisValidationData}
     * @memberof GlobalFilterValidationData
     */
    fareBasis?: FareBasisValidationData;
}

export function GlobalFilterValidationDataFromJSON(json: any): GlobalFilterValidationData {
    return GlobalFilterValidationDataFromJSONTyped(json, false);
}

export function GlobalFilterValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'effectiveDates': !exists(json, 'effectiveDates') ? undefined : ValidationMessageFromJSON(json['effectiveDates']),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : ValidationMessageFromJSON(json['distributionChannels']),
        'agenciesAndGroups': !exists(json, 'agenciesAndGroups') ? undefined : ValidationMessageFromJSON(json['agenciesAndGroups']),
        'routes': !exists(json, 'routes') ? undefined : ValidationMessageFromJSON(json['routes']),
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : ValidationMessageFromJSON(json['salesJourneys']),
        'marketingFlightNumbers': !exists(json, 'marketingFlightNumbers') ? undefined : ValidationMessageFromJSON(json['marketingFlightNumbers']),
        'providers': !exists(json, 'providers') ? undefined : ValidationMessageFromJSON(json['providers']),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : ValidationMessageFromJSON(json['fareTypes']),
        'carriers': !exists(json, 'carriers') ? undefined : ValidationMessageFromJSON(json['carriers']),
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : ValidationMessageFromJSON(json['bookingClasses']),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : ValidationMessageFromJSON(json['accountCodes']),
        'fareBasis': !exists(json, 'fareBasis') ? undefined : FareBasisValidationDataFromJSON(json['fareBasis']),
    };
}

export function GlobalFilterValidationDataToJSON(value?: GlobalFilterValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': ValidationMessageToJSON(value.description),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'effectiveDates': ValidationMessageToJSON(value.effectiveDates),
        'distributionChannels': ValidationMessageToJSON(value.distributionChannels),
        'agenciesAndGroups': ValidationMessageToJSON(value.agenciesAndGroups),
        'routes': ValidationMessageToJSON(value.routes),
        'salesJourneys': ValidationMessageToJSON(value.salesJourneys),
        'marketingFlightNumbers': ValidationMessageToJSON(value.marketingFlightNumbers),
        'providers': ValidationMessageToJSON(value.providers),
        'fareTypes': ValidationMessageToJSON(value.fareTypes),
        'carriers': ValidationMessageToJSON(value.carriers),
        'bookingClasses': ValidationMessageToJSON(value.bookingClasses),
        'accountCodes': ValidationMessageToJSON(value.accountCodes),
        'fareBasis': FareBasisValidationDataToJSON(value.fareBasis),
    };
}


